<template>
  <div class="tw:flex tw:flex-col tw:items-start">
    <div class="tw:mb-4" aria-hidden="true">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M34.9999 30.8162C34.9999 32.2045 33.7866 33.3328 32.2966 33.3328H7.67325C6.19825 33.3328 4.99992 32.2178 4.99992 30.8462V16.6662H8.33325V29.1662C8.33325 29.6278 8.70659 29.9995 9.16659 29.9995C9.62659 29.9995 9.99992 29.6278 9.99992 29.1662V10.8328C9.99992 9.45451 11.4833 8.33285 12.9633 8.33285H32.3149C33.7949 8.33285 34.9999 9.45451 34.9999 10.8328V30.8162ZM32.3149 6.66618H12.9633C10.5633 6.66618 8.33325 8.53618 8.33325 10.8328V14.9995H4.16659C3.70659 14.9995 3.33325 15.3728 3.33325 15.8328V30.8462C3.33325 33.1362 5.27992 34.9995 7.67325 34.9995H32.2966C34.7066 34.9995 36.6666 33.1228 36.6666 30.8162V10.8328C36.6666 8.53618 34.7149 6.66618 32.3149 6.66618V6.66618Z"
          fill="#171717" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.9025 13.3333H14.0975C13.6759 13.3333 13.3325 13.7067 13.3325 14.1667C13.3325 14.6267 13.6759 15 14.0975 15H30.9025C31.3242 15 31.6659 14.6267 31.6659 14.1667C31.6659 13.7067 31.3242 13.3333 30.9025 13.3333"
          fill="#171717" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.9025 20H14.0975C13.6759 20 13.3325 20.3734 13.3325 20.8334C13.3325 21.2934 13.6759 21.6667 14.0975 21.6667H30.9025C31.3242 21.6667 31.6659 21.2934 31.6659 20.8334C31.6659 20.3734 31.3242 20 30.9025 20"
          fill="#171717" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.9025 26.6667H14.0975C13.6759 26.6667 13.3325 27.04 13.3325 27.5C13.3325 27.96 13.6759 28.3333 14.0975 28.3333H30.9025C31.3242 28.3333 31.6659 27.96 31.6659 27.5C31.6659 27.04 31.3242 26.6667 30.9025 26.6667"
          fill="#171717" />
      </svg>
    </div>
    <div class="tw:mb-4">
      <h3 class="tw:text-2xl tw:font-bold tw:mb-2">{{ $t('description_add_header') }}</h3>
      <p>{{ $t('add_description_subtext') }}</p>
    </div>
    <PropertyDescriptionSelectLanguage ctaLabelKey="description_language_cta" @languageSelected="emit('languageSelected', $event)" />
  </div>
</template>

<script setup>
import PropertyDescriptionSelectLanguage from '@/components/propertyDetails/propertyDescriptions/PropertyDescriptionSelectLanguage.vue'

const emit = defineEmits(['languageSelected'])
</script>
